import { render, staticRenderFns } from "./BookingSrTableOog.vue?vue&type=template&id=12d9cdea&scoped=true"
import script from "./BookingSrTableOog.vue?vue&type=script&lang=js"
export * from "./BookingSrTableOog.vue?vue&type=script&lang=js"
import style0 from "./BookingSrTableOog.vue?vue&type=style&index=0&id=12d9cdea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9cdea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d9cdea')) {
      api.createRecord('12d9cdea', component.options)
    } else {
      api.reload('12d9cdea', component.options)
    }
    module.hot.accept("./BookingSrTableOog.vue?vue&type=template&id=12d9cdea&scoped=true", function () {
      api.rerender('12d9cdea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/BookingSrTableOog.vue"
export default component.exports